var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 88,
    viewBox: "0 0 214 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.033 18.6406C124.158 11.2656 83.4227 11.7156 47.2717 23.2839C34.339 27.4224 21.354 39.1289 26.6211 54.1987C32.0698 69.7882 53.0826 76.7775 67.1891 80.348C98.289 88.2197 132.899 87.8461 163.721 78.7595C173.965 75.7397 185.032 70.7418 193.781 64.4629C200.438 59.6855 211.961 49.994 212.415 40.6353C212.699 34.7878 208.32 32.1883 203.923 29.4547C190.144 20.8892 173.145 15.9384 157.612 11.92C123.163 3.00808 84.4325 -1.94473 49.2878 5.93253C37.6993 8.52996 30.4303 11.36 20.7558 17.8463C11.3723 24.1375 8.21038 31.237 1.57153 39.5356",
    stroke: "black",
    strokeWidth: 2.69981,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCircle);
export default __webpack_public_path__ + "static/media/create-circle.535820a71eb262629c690d000bb6c22a.svg";
export { ForwardRef as ReactComponent };